'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapHttpClient = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _raven = require('../raven');

var wrapHttpClient = exports.wrapHttpClient = function wrapHttpClient(httpClient) {
  var requestWithMethod = function requestWithMethod(method) {
    return function (url, options) {
      return httpClient(url, _extends({}, options, { method: method })).then(function (_ref) {
        var data = _ref.data;
        return data;
      }).catch(_raven.catchAndRethrowNetworkError);
    };
  };

  return {
    get: requestWithMethod('GET'),
    put: requestWithMethod('PUT'),
    post: requestWithMethod('POST'),
    delete: requestWithMethod('DELETE')
  };
};